import apiFileUpload from './functions/apiFileUpload';
import apiRelationFileUpload from './functions/apiRelationFileUpload';

const file = {
  fileUpload: apiFileUpload,
  relationFileUpload: apiRelationFileUpload
};

export default file;
